var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-product',{attrs:{"config":_vm.config,"value":_vm.selected},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }